/**
 *
 * @param level
 */
export function getSpellLevelPactMagicRequestsDataKey(level) {
    switch (level) {
        case 1:
            return 'level1';
        case 2:
            return 'level2';
        case 3:
            return 'level3';
        case 4:
            return 'level4';
        case 5:
            return 'level5';
    }
    return null;
}
/**
 *
 * @param level
 */
export function getSpellLevelSpellSlotRequestsDataKey(level) {
    switch (level) {
        case 1:
            return 'level1';
        case 2:
            return 'level2';
        case 3:
            return 'level3';
        case 4:
            return 'level4';
        case 5:
            return 'level5';
        case 6:
            return 'level6';
        case 7:
            return 'level7';
        case 8:
            return 'level8';
        case 9:
            return 'level9';
    }
    return null;
}
